<app-auth-layout
  art="wrong-key"
  [branded]="true"
  headline="You're at the right address."
  blurb="This portal belongs to one organization. Sign in with the account that organization registered and everything here is yours."
>
  <app-access-denied
    [logoUrl]="branding().logoUrl"
    [logoAlt]="branding().displayName"
    [eyebrow]="branding().displayName + ' · Davaco Customer Portal'"
    heading="No access to this organization"
    advisory="Ask your organization's admin or your Davaco account manager to add you, or sign in with the account your organization registered."
    actionLabel="Try another account"
    [code]="'org_membership_required · ref ' + reference()"
    (action)="signOut()"
  >
    @if (email() !== '') {
      <b>{{ email() }}</b> isn't a member of {{ branding().displayName }} on the Davaco
      Customer Portal.
    } @else {
      Your account isn't a member of {{ branding().displayName }} on the Davaco Customer
      Portal.
    }
  </app-access-denied>
</app-auth-layout>
